exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "client-list md-table-container .md-table tr:hover td:first-child{text-decoration:underline}client-list .filters{display:flex;align-items:center;justify-content:flex-end;font-size:12px;font-weight:700;border-bottom:1px solid #d3d3d3}client-list .filters div{margin:0 10px;padding:0 20px}client-list .filters div md-select{width:120px;max-width:120px;margin:15px 0 18px}client-list .filters .divider{height:30px;border-left:1px solid #d3d3d3;padding:0}client-list .reverse{transform:rotate(180deg)}client-list md-select.md-table-select>.md-select-value>span>.md-text{display:inline-block!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/clients/client-list/client-list.scss
// module id = 511
// module chunks = 0